import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import "./Footer.css";

const SUPPORT_EMAIL = "support@hostingnoodle.com";

const Footer = () => {
  return (
    <footer className="hn-footer">
      <Container>
        <Row className="hn-footer-top py-4">
          <Col md="4" className="mb-4 mb-md-0">
            <span className="hn-footer-brand">
              <i className="fas fa-bowl-food me-1" aria-hidden="true" />
              Hosting Noodle
            </span>
            <p className="hn-footer-tagline mt-2 mb-0">Hosting the Noodle Way 🍜</p>
          </Col>
          <Col md="8">
            <Row>
              <Col xs="6" md="4">
                <h3 className="hn-footer-heading">Products</h3>
                <ul className="hn-footer-list">
                  <li><Link to="/#hn-plans">Baremetal Servers</Link></li>
                  <li><Link to="/#hn-plans-cloud">Virtual Servers</Link></li>
                  <li><Link to="/#hn-plans-devop">DevOps Services</Link></li>
                  <li><Link to="/#hn-plans-remote">Remote Desktop</Link></li>
                </ul>
              </Col>
              <Col xs="6" md="4">
                <h3 className="hn-footer-heading">Contact</h3>
                <ul className="hn-footer-list">
                  <li><Link to="/report-abuse">Report Abuse</Link></li>
                  <li><Link to="/support">Support</Link></li>
                  <li><Link to="/sales">Sales</Link></li>
                </ul>
              </Col>
              <Col xs="6" md="4">
                <h3 className="hn-footer-heading">Company</h3>
                <ul className="hn-footer-list">
                  <li><Link to="/about">About us</Link></li>
                  <li><Link to="/pricing">Pricing</Link></li>
                  <li><Link to="/use-cases">Use cases</Link></li>
                  <li><Link to="/terms">Terms of Service</Link></li>
                  <li><Link to="/refund-policy">Refund Policy</Link></li>
                  <li><Link to="/acceptable-use-policy">Acceptable Use Policy</Link></li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="text-center py-2 hn-footer-copy">
            &copy; {new Date().getFullYear()} Hosting Noodle. All rights reserved.
          </Col>
        </Row>
        <Row>
          <Col className="text-center py-2 hn-footer-legal">
            We use cookies to improve your experience. See <Link to="/privacy-policy">Privacy &amp; cookies</Link> for details.
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
export { SUPPORT_EMAIL };
